import UploadDocumentForm from 'components/Forms/UploadDocumentForm';
import { createBookingDocument } from 'api/node/bookings';
import { decodeId } from 'utils';
import { createHotelKeeperBookingDocument } from 'api/node/hotelkeeper';
import { useError } from 'hooks';

export default function UploadDocument({
  bookingId,
  secret,
  children,
  loaderClass,
  onUpload,
  privateMode,
}) {
  const { sendErrorSnack } = useError();
  const onSubmit = async (values, methods) => {
    methods.setSubmitting(true);
    try {
      const body = new FormData();

      body.append('input', JSON.stringify({ ...values, private: privateMode }));
      body.append('document', values.document);

      if (secret) {
        await createHotelKeeperBookingDocument({ secret, data: body });
      } else {
        await createBookingDocument({
          bookingId: decodeId(bookingId),
          data: body,
        });
      }

      onUpload();
    } catch (error) {
      sendErrorSnack(error);
    }
    methods.setSubmitting(false);
  };

  const initialValues = {
    adminBookingId: bookingId,
    secret: secret,
    document: null,
  };

  return (
    <UploadDocumentForm
      onUpload={onSubmit}
      initialValues={initialValues}
      loaderClass={loaderClass}
    >
      {children}
    </UploadDocumentForm>
  );
}
